export const GET_INIT_DATA = 'publish/GET_INIT_DATA';
export const POST_FORM_DATA = 'publish/POST_FORM_DATA';
export const SUBMIT_STATE = 'publish/SUBMIT_STATE';